var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatBolt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 15.0102,
    height: 20.0028,
    viewBox: "0 0 15.0102 20.0028",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Symbol",
    d: "M12.3879 1.75921C12.6223 1.16025 12.4921 0.652437 11.9973 0.23577C11.4504 -0.102772 10.9296 -0.0767299 10.4348 0.313895L0.434783 9.0639C0.0181159 9.45452 -0.0990716 9.91025 0.0832201 10.4311C0.317595 10.9519 0.70822 11.2254 1.2551 11.2514H5.6301L2.62228 18.2436C2.38791 18.8425 2.51812 19.3504 3.01291 19.767C3.55978 20.1056 4.08062 20.0795 4.57541 19.6889L14.5754 10.9389C14.9921 10.5483 15.1093 10.0925 14.927 9.57171C14.7186 9.05087 14.328 8.77744 13.7551 8.7514H9.41916L12.3879 1.75921V1.75921V1.75921",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatBolt);
export default __webpack_public_path__ + "static/media/stat-bolt.3be930969ed3fc5bc86076f3eb227f19.svg";
export { ForwardRef as ReactComponent };